import { Form, Input, Button, Select } from 'antd';
import React from 'react';
import DatePicker from '../DatePicker';



class TableSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
    };
  }

  setFormData(data = {}) {
    this.setState((state) => {
      state.formData = { ...state.formData, ...data };
      return state;
    });
  }

  getFormData() {
    return this.state.formData;
  }

  renderInput(item) {
    const onchange = (e) => {
      this.setFormData({ [item.key]: e.target.value });
    };
    const value = this.state.formData[item.key];
    return (
      <Form.Item
        key={item.key}
        style={{ width: item.width || this.props.width || 140 }}
      >
        <Input
          value={value}
          placeholder={item.placeholder || '请输入'}
          onInput={onchange}
        />
      </Form.Item>
    );
  }

  renderSelect(item) {
    const onChange = (e) => {
      this.setFormData({ [item.key]: e });
    };
    const value = this.state.formData[item.key] ;
    return (
      <Form.Item
        key={item.key}
        style={{ width: item.width || this.props.width || 140 }}
      >
        <Select
          value={value}
          onChange={onChange}
          style={{ width: item.width || this.props.width || 140 }}
          placeholder={item.placeholder || '请选择'}
        >
          {(item.options || []).map((e) => (
            <Select.Option key={e.value} value={e.value}>
              {e.title}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    );
  }

  renderDate(item) {
    const value = this.state.formData[item.key];
    const onChange = (_date, dateString) => {
      this.setFormData({ [item.key]: dateString });
    };
    return (
      <Form.Item
        key={item.key}
        style={{ width: item.width || this.props.width || 140 }}
      >
        <DatePicker
          placeholder={item.placeholder || '请选择'}
          value={value}
          onChange={onChange}
        />
      </Form.Item>
    );
  }

  renderFormItem(list = []) {
    return list.map((e) => {
      if (e.hide) return null;
      switch (e.type) {
        case 'input':
          return this.renderInput(e);
        case 'select':
          return this.renderSelect(e);
        case 'date':
          return this.renderDate(e);
        case 'datetime':
          return this.renderInput(e);
        default:
          return null;
      }
    });
  }

  renderAction() {
    const onSubmit = () => {
      const value = this.getFormData();
      if (this.props.onSubmit) {
        this.props.onSubmit(value);
      }
    };
    const onReset = () => {
      this.setState({ formData: {} }, () => {
        if (this.props.onSubmit) {
          this.props.onSubmit({});
        }
        if (this.props.onReset) {
          this.props.onReset({});
        }
      });
    };
    return (
      <Form.Item>
        <Button type="primary" onClick={onSubmit} style={{ marginRight: 16 }}>
          查询
        </Button>
        <Button onClick={onReset}>重置</Button>
      </Form.Item>
    );
  }

  render() {
    const styles = {
      display: 'flex',
      justifyContent: 'space-between',
    };
    return (
      <div style={styles}>
        <Form layout="inline">
          {this.renderFormItem(this.props.options)}
          {this.renderAction()}
        </Form>

        {this.props.children}
      </div>
    );
  }
}

export default TableSearch;



// WEBPACK FOOTER //
// ./src/components/TableSearch/index.jsx